import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=16368cbf&scoped=true&lang=html&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16368cbf",
  null
  
)

export default component.exports